module.exports = __webpack_public_path__ + "img/girl.22781177.svg";